import { Page, Row, RowrowComponentsUnion } from '@/lib/types';

export const getPageComponents = (
  page: Page,
  componentCheck: (rc: RowrowComponentsUnion) => boolean
) => {
  const components: RowrowComponentsUnion[] = [];

  page?.sections.forEach((section) => {
    return section.rows.forEach((row) => {
      if (row.__typename === 'Row') {
        return (row as Row).rowComponents.forEach(
          (rc: RowrowComponentsUnion) => {
            if (componentCheck(rc)) {
              components.push(rc);
            }
          }
        );
      }
    });
  });

  return components;
};
